import { Tooltip } from '@mui/material';
import { ActionIconButton } from '../../../common/components';
import { INTERNAL_ORDERS_TABLE_TEXTS as TEXTS } from '../constants/internalOrdersConstants';

/**
 * Botón de detalle del pedido con tooltip.
 * @param {Object} props
 * @param {Function} props.onClick Abre el detalle.
 * @param {boolean} props.disabled Deshabilita la acción.
 * @returns {JSX.Element}
 */
const InternalOrderViewButton = ({ onClick, disabled }) => (
  <Tooltip title={TEXTS.view}>
    <span>
      <ActionIconButton variant="view" onClick={onClick} disabled={disabled} />
    </span>
  </Tooltip>
);

export default InternalOrderViewButton;
